/**
 * A WhatsApp link with a prefilled message. With a phone number the chat
 * opens with that number (ten-digit Indian numbers get the 91 country code);
 * without one, WhatsApp asks whom to send it to.
 */
export function whatsappLink(phone: string | null | undefined, text: string): string {
	let digits = (phone ?? "").replace(/\D/g, "");
	if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
	if (digits.length === 10) digits = `91${digits}`;
	const to = digits.length >= 10 ? digits : "";
	return `https://wa.me/${to}?text=${encodeURIComponent(text)}`;
}
